<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Search-Correspondence",
  path: "correspondence",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
